import React from 'react'
import { useSelector } from 'react-redux'
const useReduxData = () => {
    const redux_data = useSelector((state: any) => state);
    // console.log("_redux_data",redux_data)
    return redux_data;
}

export default useReduxData